module.exports = __webpack_public_path__ + "static/media/RoomService_Meal1_Categories.1982d7ca.png";